import { render, staticRenderFns } from "./DynamicCollapsableSideBar.vue?vue&type=template&id=12cf503f&scoped=true&"
import script from "./DynamicCollapsableSideBar.vue?vue&type=script&lang=js&"
export * from "./DynamicCollapsableSideBar.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCollapsableSideBar.vue?vue&type=style&index=0&id=12cf503f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf503f",
  null
  
)

export default component.exports